import { cleanNumber, isValidNumber } from '@gripp/shared-logic';
import { useState } from 'react';
import { Text, View } from 'react-native';
import { Colors } from '../../../themes/colors';
import { MaskedNumberInput } from '../../forms';
import { CounterExecutionComponentProps } from './counterExecutionComponent';
import { themedStyleSheet } from '../../../themes/themedStyleSheet';

export const SimpleCounterExecutionComponent = (
  props: CounterExecutionComponentProps
) => {
  // Use props.value if available (from form/draft or revision), otherwise blank
  const [inputValue, setInputValue] = useState<string>(
    props.value != null && !Number.isNaN(props.value)
      ? props.value.toString()
      : ''
  );

  const change = (raw: string) => {
    if (raw === '') {
      setInputValue('');
      props.onChange(NaN as any);
      return;
    }
    const input = cleanNumber(raw, props.decimalPlaces, true);
    setInputValue(input);
    if (isValidNumber(input)) {
      const num = parseFloat(input);
      props.onChange(num);
    } else {
      props.onChange(NaN as any);
    }
  };

  // `inputValue` is seeded once at mount, before the prefill effect runs, so a
  // locked counter has to read props.value directly. Stays a number:
  // MaskedNumberInput treats the string '0' as cleared and would blank a real
  // zero reading.
  const displayValue = props.disabled
    ? props.value != null && !Number.isNaN(props.value)
      ? props.value
      : ''
    : inputValue;

  return (
    <View
      style={props.containerStyle ? props.containerStyle : styles.container}
    >
      {props.instructions?.trim() !== '' && (
        <Text style={styles.sectionTitle}>{props.instructions}</Text>
      )}
      <View style={[styles.inputContainer, props?.inputContainerStyle]}>
        <MaskedNumberInput
          value={displayValue}
          decimalPlaces={props.decimalPlaces}
          autoFocus={props.autoFocus}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          onChangeText={(val) => change(`${val}`)}
          selectionColor={Colors.role.textSecondary}
          cursorColor={Colors.role.textSecondary}
          height={48}
          showStepper
          disabled={props.disabled}
          stepperIconColor={
            props.disabled ? Colors.role.textDisabled : undefined
          }
        />
      </View>
    </View>
  );
};

const styles = themedStyleSheet((role) => ({
  container: {
    borderRadius: 4,
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: role.textPrimary,
    letterSpacing: -0.25,
  },
  inputContainer: {
    width: '100%',
    height: 48,
    marginTop: 20,
    flexDirection: 'row',
    borderRadius: 4,
    overflow: 'hidden',
  },
}));
